var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNesoFuelFullC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7458 10.9219L45.0719 20.248L43.3348 21.9853L34.0087 12.6593L35.7458 10.9219Z",
    fillOpacity: 0.12,
    fill: "var(--theme-contrast-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5083 5.49014C36.964 5.03454 37.7028 5.03454 38.1585 5.49014L50.5083 17.8402C50.964 18.2958 50.964 19.0345 50.5083 19.4901L48.8584 21.1401C48.403 21.5957 47.6642 21.5957 47.2085 21.1401L34.8584 8.78999C34.403 8.33436 34.403 7.59567 34.8584 7.14007L36.5083 5.49014Z",
    fillOpacity: 0.12,
    fill: "var(--theme-contrast-color)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8334 7.0013C12.189 7.0013 11.6667 7.52364 11.6667 8.16797V11.668H9.33337V8.16797C9.33337 6.23497 10.9004 4.66797 12.8334 4.66797H24.5C26.433 4.66797 28 6.23497 28 8.16797V11.668H25.6667V8.16797C25.6667 7.52364 25.1443 7.0013 24.5 7.0013H12.8334Z",
    fillOpacity: 0.12,
    fill: "var(--theme-contrast-color)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33329 11.668C6.75596 11.668 4.66663 13.7573 4.66663 16.3346V46.668C4.66663 49.2454 6.75596 51.3346 9.33329 51.3346H39.6666C42.244 51.3346 44.3333 49.2454 44.3333 46.668V26.0016C44.3333 24.7647 43.8424 23.5785 42.9681 22.7034L38.1355 17.8659L33.3043 13.0348C32.4291 12.1596 31.2421 11.668 30.0045 11.668H9.33329ZM28 21.0013L16.3333 35.0013H21L18.6666 44.3346L30.3333 30.3346H25.6666L28 21.0013Z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5622 27.2172) rotate(129.037) scale(31.1107 26.5845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNesoFuelFullC);
export default __webpack_public_path__ + "static/media/NesoFuelFullC.d26aecf3.svg";
export { ForwardRef as ReactComponent };